import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SsoLoginComponent } from './sso-login.component';
import { IconModule } from '../icons/icon/icon.module';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzFormModule } from 'ng-zorro-antd/form';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';

@NgModule({
  declarations: [SsoLoginComponent],
  imports: [
    CommonModule,
    IconModule,
    NzButtonModule,
    NzIconModule,
    NzFormModule,
    FormsModule,
    ReactiveFormsModule,
    NzIconModule,
    NzInputModule,
  ],
  exports: [SsoLoginComponent],
})
export class SsoLoginModule { }
